import { motion } from "framer-motion";
import { GALLERY, INSTAGRAM } from "@/lib/site";
import { Instagram } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Gallery = () => (
    <section id="gallery" className="mx-auto max-w-7xl px-5 pb-20 sm:px-8 md:pb-28" data-testid="gallery-section">
        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: EASE }}
            className="mb-12 flex flex-col gap-4 md:mb-16 md:flex-row md:items-end md:justify-between"
        >
            <div>
                <p className="text-xs font-bold uppercase tracking-[0.32em] text-sky-600">
                    Real work
                </p>
                <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-sakura-900 sm:text-5xl">
                    Fresh from
                    <span className="italic text-sakura-600"> the press</span>
                </h2>
            </div>
            <a
                data-testid="gallery-instagram-link"
                href={INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-fit items-center gap-2 rounded-full border border-sky-600/40 px-5 py-3 text-sm font-semibold text-sky-700 hover:bg-sky-600 hover:text-white transition-colors duration-200"
            >
                <Instagram size={16} />
                @Cherryblossomgift
            </a>
        </motion.div>

        <div className="columns-2 gap-4 sm:gap-5 lg:columns-4">
            {GALLERY.map((g, i) => (
                <motion.figure
                    key={g.src}
                    data-testid={`gallery-item-${i}`}
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.15 }}
                    transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: EASE }}
                    className="group mb-4 break-inside-avoid overflow-hidden rounded-3xl border border-sakura-400/40 bg-white shadow-[0_10px_30px_rgba(162,182,208,0.18)] sm:mb-5"
                >
                    <img
                        src={g.src}
                        alt={g.caption}
                        loading="lazy"
                        className="w-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
                    />
                    <figcaption className="px-4 py-3 text-xs font-medium text-sakura-800/80">
                        {g.caption}
                    </figcaption>
                </motion.figure>
            ))}
        </div>
    </section>
);

export default Gallery;
